export * from '@gusiberi/shared'

/** Web env — shared uses getAwsBaseUrl() from platform. */
export const AWS_BASE_URL = process.env.REACT_APP_AWS_BASE_URL
